import { render } from "./SceneInPathComputed.vue?vue&type=template&id=4fa8fab5&scoped=true"
import script from "./SceneInPathComputed.vue?vue&type=script&lang=js"
export * from "./SceneInPathComputed.vue?vue&type=script&lang=js"

import "./SceneInPathComputed.vue?vue&type=style&index=0&id=4fa8fab5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa8fab5"]])

export default __exports__